import React from 'react';
import PropTypes from 'prop-types';
import { getFontFamilyWithFallback } from '@sendwise/font-helpers';

import Link from '../Link';

import './Promo.module.scss';

const Promo = ({ designSettings }) => {
  const {
    promoBackgroundColor: backgroundColor,
    promoTextColor: color,
    promoLinkColor,
    promoLinkHoverColor,
    bodyFont,
  } = designSettings;

  const fontFamily = getFontFamilyWithFallback(bodyFont);

  return (
    <span styleName="promo" style={{backgroundColor, color, fontFamily}}>
      Parcel tracking powered by&nbsp;<Link href="http://sevensenders.com" color={promoLinkColor} hoverColor={promoLinkHoverColor}>sevensenders.com</Link>
    </span>
  );
};

Promo.propTypes = {
  designSettings: PropTypes.shape({
    promoBackgroundColor: PropTypes.string,
    promoTextColor: PropTypes.string,
    promoLinkColor: PropTypes.string,
    promoLinkHoverColor: PropTypes.string,
    bodyFont: PropTypes.string,
  }),
};

export default Promo;


// WEBPACK FOOTER //
// ./src/js/widgets/Footer/Promo.js